import React from 'react'
import { Layout, Stack, Hero, Main, Sidebar, PreFooter } from '@layout'
import { Box, Text, Flex, Button } from 'theme-ui'
import Section from '@components/Section'
import CardList from '@components/CardList'
import Card from '@components/Card'
import Sticky from '@components/Sticky'
import Divider from '@components/Divider'
import Pagination from '@components/Pagination'
import Seo from '@widgets/Seo'
import Categories from '@widgets/Categories'
import Tags from '@widgets/Tags'
import NewsletterCompact from '@widgets/NewsletterCompact'
import Social from '@widgets/Social'
import HeroComponent from '../components/Hero/Hero'
import { useBlogTags, useBlogCategories } from '@helpers-blog'

const Posts = ({ data: { paginatedPosts = {} }, ...props }) => {
  const { pageContext: { services = {}, basePath } = {} } = props
  const tags = useBlogTags()
  const categories = useBlogCategories()

  return (
    <Layout {...props}>
      <Seo title='Home' />
      <Hero sx={{ bg: `contentBg` }}>
        <HeroComponent {...props} />
      </Hero>
      <Divider />
      <Stack>
        <Main>
          <Flex>
            <Box>
              <Section title='Psychotherapie'>
              <Text variant='p'>
Grundlegend für einen Therapieerfolg ist eine vertrauensvolle und verlässliche therapeutische Beziehung.
Hierfür bemühe ich mich um eine unvoreingenommene, bewertungsfreie und unwissende Haltung. Neben störungsspezifischen Therapiebausteinen
können mentalisierungsbasierte, schematherapeutische, imaginative, ressourcenorientierte und vor allem
validierende Inhalte Anwendung finden.
</Text>
<Text variant='p'>
In der Psychotherapie geht es um Schwierigkeiten, aber auch um Stärken.
Ein sich schrittweise entwickelndes Verständnis für eigene Gefühle, Gedanken und
Verhaltensweisen kann heilsam sein. Dabei
möchte ich Sie unterstützend begleiten. Im Allgemeinen wird davon ausgegangen, dass
Verhaltenstherapie viel auf Veränderung setzt. Aber auch Akzeptanz des eigenen Erlebens und damit einhergehende Besonderheiten
können im Mittelpunkt stehen. Im Rahmen meiner Fortbildungen und im beruflichen Miteinander mit Kolleg:innen 
ist mir der Austausch zwischen den einzelnen Therapieschulen und das gegenseitige sich Annähern besonders wichtig.
              </Text>
              </Section>
      <Divider />
      <Divider />
              <Section title='Psychotherapeutische Sprechstunde'>
              <Text variant='p'>
In der Psychotherapeutischen Sprechstunde geht es um die Einordnung Ihres Anliegens.
Hilfreich hierbei ist eine biografische Anamnese. So können derzeitige und frühere
Symptome passender eingeschätzt und Ressourcen erkannt werden.
Ich bemühe mich darum, mögliche Diagnosen individuell
zu erläutern. Es wird geklärt, ob eine ambulante Psychotherapie in Frage kommen könnte.

</Text>
              </Section>
      <Divider />
      <Divider />
              <Section title='Diagnostik'>
              <Text variant='p'>
                Leider biete ich eine Autismus- oder ADHS-Diagnostik aus praxisorganisatorischen Gründen nur in Ausnahmefällen und während einer laufenden Behandlung an.
              </Text>
              </Section>
            </Box>
          </Flex>
        </Main>
      </Stack>
      <Divider />
      <PreFooter>
        <Pagination {...paginatedPosts.pageInfo} basePath={basePath} />
      </PreFooter>
    </Layout>
  )
}

export default Posts
